<template>
  <div class="safe-html" :class="{ 'is-plain': isPlainText }" v-html="sanitized"></div>
</template>

<script>
/**
 * 富文本安全渲染（Vue2 版本，无 DOMPurify 依赖）
 * 通过 DOM 白名单方式清洗脚本/事件/危险链接，并给 <a> 补 target/rel。
 */
const HAS_HTML_TAG = /<[a-z][\s\S]*>/i

export default {
  name: 'SafeHtml',
  props: {
    html: {
      type: String,
      default: ''
    }
  },
  computed: {
    isPlainText() {
      return !HAS_HTML_TAG.test(this.html || '')
    },
    sanitized() {
      return this.sanitize(this.html || '')
    }
  },
  methods: {
    sanitize(raw) {
      if (!raw) return ''
      const el = document.createElement('div')
      el.innerHTML = raw
      // 移除危险标签
      const danger = el.querySelectorAll('script, style, iframe, object, embed, link, meta, base, form')
      const dArr = Array.prototype.slice.call(danger)
      dArr.forEach(n => n.parentNode && n.parentNode.removeChild(n))
      // 清理属性：on*、危险协议、srcdoc
      const all = el.querySelectorAll('*')
      const aArr = Array.prototype.slice.call(all)
      aArr.forEach(n => {
        const attrs = Array.prototype.slice.call(n.attributes)
        attrs.forEach(a => {
          const name = (a.name || '').toLowerCase()
          const val = (a.value || '').toLowerCase()
          if (
            name.startsWith('on') ||
            name === 'srcdoc' ||
            ((name === 'href' || name === 'src' || name === 'xlink:href') && (val.startsWith('javascript:') || val.startsWith('data:')))
          ) {
            n.removeAttribute(a.name)
          }
        })
        if (n.tagName === 'A') {
          n.setAttribute('target', '_blank')
          n.setAttribute('rel', 'noopener noreferrer')
        }
      })
      return el.innerHTML
    }
  }
}
</script>

<style scoped>
.safe-html {
  word-break: break-word;
}
.safe-html.is-plain {
  white-space: pre-wrap;
}
</style>